/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable max-lines */
/* eslint-disable complexity */
import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  Output,
  Renderer2,
  SimpleChanges
} from '@angular/core';
import { AbstractControl, ValidationErrors } from '@angular/forms';
import { ContactInfoValidationService } from '../services/validation-service';

@Directive({
  selector: '[idpValidateCIOnBlur]'
})
export class ValidateOnBlurDirective implements OnInit, OnChanges {
  @Input() validateFormControl!: AbstractControl;
  @Input() validationErrorsArr!: any[];
  @Input() ofopModal = false;
  @Input() errorCode!: any;
  @Output() errorsCountChanged: EventEmitter<any> = new EventEmitter();
  public hasErrorToolTip = false;
  errorMsg!: string;

  constructor(
    private elementRef: ElementRef,
    private ren: Renderer2,
    private errorMessageService: ContactInfoValidationService
  ) {}

  @HostListener('focus', ['$event.target'])
  onFocus(target?: HTMLElement) {
    const formControlName =
      this.elementRef.nativeElement.getAttribute('formControlName');

    const errorMsg = this.errorMessageService.fetchErrorMsg(
      this.validateFormControl,
      formControlName,
      this.errorCode
    );
    if (errorMsg && errorMsg.errorMessage) {
      this.errorMsg = errorMsg.errorMessage;
    } else {
      this.errorMsg = errorMsg;
    }
    this.displayErrorToolTip();
  }

  /**
   * display error tool tip
   */
  displayErrorToolTip() {
    for (
      let i = 0;
      i < this.elementRef.nativeElement.parentElement.children.length;
      i++
    ) {
      if (
        this.elementRef.nativeElement.parentElement.children[
          i
        ].classList.contains('errorTooltip')
      ) {
        this.elementRef.nativeElement.parentElement.children[
          i
        ].children[0].innerText = '';
        const text = this.ren.createText(this.errorMsg);
        this.ren.appendChild(
          this.elementRef.nativeElement.parentElement.children[i].children[0],
          text
        );
        this.ren.setStyle(
          this.elementRef.nativeElement.parentElement.children[i],
          'display',
          'block'
        );
      }
    }
  }

  @HostListener('focusout', ['$event.target'])
  onFocusout() {
    this.validateField();
    const id = this.elementRef.nativeElement.getAttribute('id');
    if (this.validationErrorsArr && this.validateFormControl.touched) {
      this.checkErrors(id);
    }
  }

  /**
   * check errors
   */
  checkErrors(id: string) {
    if (this.validateFormControl.invalid) {
      this.invalidFormCheck(id);
    } else if (this.validateFormControl.valid) {
      this.updateErrorCount(id);
    }
  }

  /**
   * update errors
   */
  updateErrorCount(id: string) {
    for (let i = 0; i < this.validationErrorsArr.length; i++) {
      if (this.validationErrorsArr[i].fieldname === id) {
        this.validationErrorsArr.splice(i, 1);
      }
    }
    this.errorsCountChanged.emit(this.validationErrorsArr);
  }

  /**
   * check invalid fields
   */
  invalidFormCheck(id: string) {
    let idFound = false;
    for (let i = 0; i < this.validationErrorsArr.length; i++) {
      if (this.validationErrorsArr[i].fieldname === id) {
        idFound = true;
      }
    }
    const errorObj = {} as {
      fieldname: string;
      errorValue: ValidationErrors | null;
    };
    errorObj['fieldname'] = id;
    errorObj['errorValue'] = this.validateFormControl.errors;
    if (!idFound) {
      this.validationErrorsArr.push(errorObj);
    }
    this.errorsCountChanged.emit(this.validationErrorsArr);
  }

  ngOnInit() {
    this.hasErrorToolTip = false;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['validationErrorsArr']) {
      if (!changes['validationErrorsArr'].firstChange) {
        this.validateField();
      }
    }
  }

  /**
   * check field validations
   */
  validateField() {
    const id = this.elementRef.nativeElement.getAttribute('id');
    this.validateFormControl.markAsTouched();
    if (this.validateFormControl.touched) {
      this.checkFieldError(id);
    }
  }

  /**
   * check field errors
   */
  checkFieldError(id: string) {
    if (this.validateFormControl.invalid) {
      this.invalidFieldCheck(id);
    } else {
      if (this.validateFormControl.valid) {
        this.validFieldCheck();
      }
    }
  }

  /**
   * check if field is valid
   */
  validFieldCheck() {
    if (
      this.elementRef.nativeElement.name.toLocaleLowerCase() !==
        'expirationdate' &&
      (this.elementRef.nativeElement.value !== '' ||
        this.elementRef.nativeElement.value === undefined)
    ) {
      this.removeErrorStyle();
    }
  }

  /**
   * check if field is invalid
   */
  invalidFieldCheck(id: string) {
    for (
      let i = 0;
      i < this.elementRef.nativeElement.parentElement.children.length;
      i++
    ) {
      if (
        this.elementRef.nativeElement.parentElement.children[
          i
        ].classList.contains('errorTooltip')
      ) {
        this.hasErrorToolTip = true;
        this.ren.setStyle(
          this.elementRef.nativeElement.parentElement.children[i],
          'display',
          'none'
        );
      }
    }
    this.setErrorToolTip(id);
  }

  /**
   * set error tool tip
   */
  setErrorToolTip(id: string) {
    if (!this.hasErrorToolTip) {
      this.ren.addClass(this.elementRef.nativeElement, 'errorText');
      const errorMsgTooltip = this.ren.createElement('div');
      this.ren.addClass(errorMsgTooltip, 'errorTooltip');
      const errorLabel = this.ren.createElement('label');
      this.ren.setAttribute(errorLabel, 'for', id);
      this.ren.appendChild(errorMsgTooltip, errorLabel);
      this.ren.setStyle(errorMsgTooltip, 'display', 'none');
      this.ren.insertBefore(
        this.elementRef.nativeElement.parentElement,
        errorMsgTooltip,
        this.elementRef.nativeElement
      );
    }
  }

  /**
   * remove error style
   */
  removeErrorStyle() {
    this.ren.removeClass(this.elementRef.nativeElement, 'errorText');
    for (
      let i = 0;
      i < this.elementRef.nativeElement.parentElement.children.length;
      i++
    ) {
      if (
        this.elementRef.nativeElement.parentElement.children[
          i
        ].classList.contains('errorTooltip')
      ) {
        this.ren.removeChild(
          this.elementRef.nativeElement.parentElement,
          this.elementRef.nativeElement.parentElement.children[i]
        );
        this.hasErrorToolTip = false;
      }
    }
  }
}
